import { AuditableModel } from '../../Misc/models/auditable.model';
import { RecipientApiModel, CreateRecipientApiModel, UpdateRecipientApiModel } from '../../../api/mailingLists/models/recipient.api.model';

export class RecipientModel implements AuditableModel {
    id: number;
    name: string;
    email: string;

    createdByUserId?: number;
    createdDate?: Date;
    modifiedByUserId?: number;
    modifiedDate?: Date;

    constructor(apiModel?: RecipientApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.email = apiModel.email;
            this.createdByUserId = apiModel.createdByUserId;
            this.createdDate = apiModel.createdDate ? new Date(apiModel.createdDate) : null;
            this.modifiedByUserId = apiModel.modifiedByUserId;
            this.modifiedDate = apiModel.modifiedDate ? new Date(apiModel.modifiedDate) : null;
        }
    }

    getCreateApiModel(): CreateRecipientApiModel {
        return {
            name: this.name || undefined,
            email: this.email
        };
    }
    getUpdateApiModel(): UpdateRecipientApiModel {
        return {
            id: this.id,
            name: this.name || undefined,
            email: this.email
        };
    }
    clone(): RecipientModel {
        return new RecipientModel({
            id: this.id,
            name: this.name,
            email: this.email,
            createdByUserId: this.createdByUserId,
            createdDate: this.createdDate ? +this.createdDate : null,
            modifiedByUserId: this.modifiedByUserId,
            modifiedDate: this.modifiedDate ? +this.modifiedDate : null
        });
    }
}
